<template>
  <div class="shadow-xs rounded">
    <div class="shadow-md rounded overflow-hidden bg-white">
      <div class="px-3 py-2 text-sm truncate">
        {{ title }}
      </div>
      <component
        :is="isLink || isMedia ? 'a' : 'div'"
        class="relative aspect-ratio-16/9 bg-gray-100"
        v-bind="elAttributes"
        :class="[isLink || isMedia ? 'block' : '']"
      >
        <img v-if="cover" :src="cover" class="absolute w-full h-full inset-0 object-cover" />
        <div v-else class="absolute w-full h-full inset-0 flex items-center justify-center">
          <div class="flex flex-col items-center space-y-4 text-sm">
            <svg viewBox="0 0 24 24" fill="currentColor" class="h-8 w-8 text-gray-600">
              <path
                v-if="type === 'notes'"
                fill="currentColor"
                class="text-yellow-600"
                d="M21 15l-6 5.996L4.002 21A.998.998 0 0 1 3 20.007V3.993C3
                      3.445 3.445 3 3.993 3h16.014c.548 0 .993.456.993 1.002V15zM19
                      5H5v14h8v-5a1 1 0 0 1 .883-.993L14 13l5-.001V5zm-.829
                      9.999L15 15v3.169l3.171-3.17z"
              />
              <path
                v-else-if="type === 'links'"
                d="M10 6v2H5v11h11v-5h2v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1
                      1 0 0 1 1-1h6zm11-3v8h-2V6.413l-7.793
                      7.794-1.414-1.414L17.585 5H13V3h8z"
              />
              <path
                v-else-if="isPDF"
                fill="currentColor"
                class="text-red-600"
                d="M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9
                      2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5
                      1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67
                      1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5
                      1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4
                      6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z"
              />
              <path
                v-else
                d="M12 16H8V8h4a4 4 0 1 1 0 8zm-2-6v4h2a2 2 0 1 0
                      0-4h-2zm5-6H5v16h14V8h-4V4zM3 2.992C3 2.444 3.447
                      2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1
                      1 0 0 1 3 21.008V2.992z"
              />
            </svg>
            <p class="text-gray-900">No preview available</p>
          </div>
        </div>
      </component>
      <div class="p-3">
        <div v-if="confirmDelete" class="space-x-2">
          <BaseButton ghost :disabled="active" @click="handleDeleteCancelation">
            Cancel
          </BaseButton>
          <BaseButton danger :disabled="active" @click="handleDelete"> Confirm </BaseButton>
        </div>
        <BaseButton v-else ghost @click="handleDeleteConfirmation"> Delete </BaseButton>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AttachmentTile',

  props: {
    id: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    attributes: {
      type: Object,
      required: true,
    },
    onDeleteAttachment: { type: Function, required: true },
  },

  data() {
    return {
      active: false,
      confirmDelete: false,
    };
  },

  computed: {
    title() {
      if (this.isLink) {
        return this.attributes.title || this.attributes.url;
      }

      if (this.isMedia) {
        return this.attributes.name;
      }

      return this.attributes.content;
    },
    cover() {
      if (this.isImage) {
        return this.attributes.url;
      }

      if (this.isLink) {
        return this.attributes?.cover || null;
      }

      return null;
    },
    isLink() {
      return this.type === 'links';
    },
    isMedia() {
      return this.type === 'media';
    },
    isImage() {
      if (this.type !== 'media') {
        return false;
      }

      return (this.attributes?.mimeType || '').indexOf('image') === 0;
    },
    isPDF() {
      if (this.type !== 'media') {
        return false;
      }

      return this.attributes?.mimeType === 'application/pdf';
    },
    elAttributes() {
      return this.isLink || this.isMedia
        ? {
            href: this.attributes.url,
            target: '_blank',
          }
        : {};
    },
  },

  methods: {
    handleDelete() {
      this.active = true;

      return this.onDeleteAttachment({ type: this.type, id: this.id })
        .then(() => {
          this.active = false;
        })
        .catch(() => {
          this.active = false;
        });
    },
    handleDeleteConfirmation() {
      this.confirmDelete = true;
      setTimeout(() => {
        if (this.active) {
          return;
        }
        this.confirmDelete = false;
      }, 3000);
    },
    handleDeleteCancelation() {
      this.confirmDelete = false;
    },
  },
};
</script>
